import type { TOC } from '@ember/component/template-only';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelMarketInsightTablesCellsTdUsualPriceSignature {
  Args: {
    displayValue: {
      formattedRoomNameAndCancellableText: string;
      formattedUsualRateDow: string;
      hasUsualRateDowValue: boolean;
    };
  };
}

const HotelMarketInsightTablesCellsTdUsualPrice = <template>
  <div>
    {{@displayValue.formattedUsualRateDow}}
  </div>

  {{#if @displayValue.hasUsualRateDowValue}}
    <PrismTooltip
      @side="right"
      @text={{@displayValue.formattedRoomNameAndCancellableText}}
    />
  {{else}}
    <PrismTooltip @side="right" @text={{t "general.not_available"}} />
  {{/if}}
</template> satisfies TOC<HotelMarketInsightTablesCellsTdUsualPriceSignature>;

export default HotelMarketInsightTablesCellsTdUsualPrice;
